"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.random = void 0;

/**
 * Generate random number between interval
 *
 * @param {Number} min Minimum value
 * @param {Number} max Maximum value
 *
 * @return {Integer}
 */
var random = function random() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Math.floor(min + Math.random() * (max - min + 1));
};

exports.random = random;